import React from 'react';

/** Toggle visibility of this components children using a boolean prop
 *  @param {object} props
 *  @param props.condition truth if props.children should be visible, false otherwise
 *  @param props.children
 **/
const ShowIf = (props: { condition: boolean; children: React.ReactFragment }) => (
  <>{props.condition && props.children}</>
);

export default ShowIf;
